import React, { useState, useEffect, useRef, useCallback } from "react";
import { Link } from "react-router-dom";
import { Modal } from "bootstrap";
import { GetOFDByDatesForSchedule } from "../api/ofd";
import { GetByNotApproved, Approve, GetById } from "../api/approved_dep";
import { DirectorLevel } from "../constants";
import AutoDepApprove from "./AutoDepApprove";
import AutoDepWeek from "./AutoDepWeek";

function formatDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

function getNextShiftId(shifts) {
  if (!shifts?.length) return 1;
  return Math.max(...shifts.map((s) => s.id || 0)) + 1;
}

function isSameShift(a, b) {
  if (!a?.id || !b?.id) return false;
  return (
    a.id === b.id &&
    a.date === b.date &&
    a.station_name === b.station_name &&
    a.start === b.start
  );
}

function getShiftKey(ts) {
  if (!ts?.id) return null;
  return `${ts.id}|${ts.date}|${ts.station_name}|${ts.start}`;
}

const MIN_AUTO_SHIFT_HOURS = 4;

function getNextWeekRange(baseDate = new Date()) {
  const today = new Date(baseDate);
  today.setHours(0, 0, 0, 0);
  const day = today.getDay();
  const diffToMonday = day === 0 ? -6 : 1 - day;
  const currentMonday = new Date(today);
  currentMonday.setDate(today.getDate() + diffToMonday);

  const nextMonday = new Date(currentMonday);
  nextMonday.setDate(currentMonday.getDate() + 7);

  const nextSunday = new Date(nextMonday);
  nextSunday.setDate(nextMonday.getDate() + 6);

  return {
    startDate: formatDate(nextMonday),
    endDate: formatDate(nextSunday),
  };
}

const AutoDep = ({ token, accessLevel }) => {
  const [startDate, setStartDate] = useState(() => getNextWeekRange().startDate);
  const [endDate, setEndDate] = useState(() => getNextWeekRange().endDate);
  const [selectedType, setSelectedType] = useState("DT");
  const [doneTemplateShifts, setDoneTemplateShifts] = useState([]);
  const [lastId, setLastId] = useState(1);
  const [receipts, setReceipts] = useState({});
  const [selectedDate, setSelectedDate] = useState();
  const [startNewTS, setStartNewTS] = useState(22);
  const [endNewTS, setEndNewTS] = useState(6);
  const [selectedTS, setSelectedTS] = useState({ start: 0, hours: 0 });
  const [startPlusEditTS, setStartPlusEditTS] = useState(0);
  const [endPlusEditTS, setEndPlusEditTS] = useState(0);
  const [TSHours, setTSHours] = useState(0);
  const [modalMessageCreate, setModalMessageCreate] = useState("");
  const [modalMessageEdit, setModalMessageEdit] = useState("");
  const [divideSelectedTS, setDivideSelectedTS] = useState(0);
  const [firstDivededTS, setFirstDiveidedTS] = useState({});
  const [secondDivededTS, setSecondDiveidedTS] = useState({});
  const [disabledApproveBtn, setDisabledApproveBtn] = useState(false);
  const [isDragging, setIsDragging] = useState(false);

  const [approves, setApproves] = useState([]);
  const [selectedApprove, setSelectedApprove] = useState({});
  const [boardReady, setBoardReady] = useState(false);
  const [boardView, setBoardView] = useState("week");
  const [shiftPalette, setShiftPalette] = useState("station");
  const [isLoadingReceipts, setIsLoadingReceipts] = useState(false);
  const [isLoadingList, setIsLoadingList] = useState(false);

  const [comment, setComment] = useState("");
  const [status, setStatus] = useState(1);
  const [approveMessage, setApproveMessage] = useState(null);
  const [isSavingDraft, setIsSavingDraft] = useState(false);
  const [editModalShift, setEditModalShift] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [pendingHistory, setPendingHistory] = useState([]);

  const dragRef = useRef(null);
  const suppressClickRef = useRef(false);
  const editShiftModalRef = useRef(null);
  const plusSnapshotRef = useRef(null);
  const editModalShiftRef = useRef(null);
  const toolbarRef = useRef(null);
  const savedTimerRef = useRef(null);
  const [toolbarOffscreen, setToolbarOffscreen] = useState(false);
  const [stickySaveStatus, setStickySaveStatus] = useState("save");
  const [stickySaveError, setStickySaveError] = useState("");

  const statuses = {
    1: "Не согласовано",
    2: "На доработке",
    3: "Согласовано",
  };

  function appendHistory(event) {
    setPendingHistory((prev) => [...prev, { ...event, at: historyNowIso() }]);
  }

  function logExtendFromSnapshot(shift) {
    const snap = plusSnapshotRef.current;
    if (!snap || !shift) return;
    const plusBefore = shift.plus_before || 0;
    const plusAfter = shift.plus_after || 0;
    if (snap.plus_before === plusBefore && snap.plus_after === plusAfter) {
      return;
    }
    appendHistory({
      type: "extend",
      ...historyShiftMeta(shift),
      from: shiftIntervalLabel(
        snap.shift || shift,
        snap.plus_before,
        snap.plus_after,
      ),
      to: shiftIntervalLabel(shift, plusBefore, plusAfter),
    });
    plusSnapshotRef.current = {
      plus_before: plusBefore,
      plus_after: plusAfter,
      shift,
    };
  }

  function createTemplateShifts(data, rangeStart = startDate, rangeEnd = endDate) {
    if (!Array.isArray(data)) {
      return [[], {}];
    }
    let id = 1;
    const hours = generateHours(rangeStart, DeltaDate(rangeEnd, +1));
    const receiptsMap = {};
    data.map((hour) => {
      receiptsMap[new Date(hour.hour).getTime()] = hour;
    });

    const stations = selectDeploiment[selectedType];
    let templateShifts = [];
    stations.map((station) => {
      let templateShiftsStation = [];
      let currentShift = false;
      hours.map((hour) => {
        let receiptsNow = 0;
        if (receiptsMap[hour.getTime()]) {
          receiptsNow = receiptsMap[hour.getTime()].receipts;
        }

        if (!currentShift) {
          if (receiptsNow >= station.min_receipts) {
            let shiftEnd = hour.getHours() + 1;
            if (shiftEnd == 24) {
              shiftEnd = 0;
            }
            let shift = {
              station_name: station.name,
              start: hour.getHours(),
              end: shiftEnd,
              hours: 1,
              date: hoursInDate(hour),
              group_station_name: station.group_station_name,
              id: id,
            };
            id += 1;
            templateShiftsStation.push(shift);
            currentShift = shift;
          }
        } else {
          if (currentShift && hour.getHours() === currentShift.end) {
            if (receiptsNow >= station.min_receipts) {
              if (currentShift.end + 1 == 24) {
                currentShift.end = 0;
                currentShift.hours = 24 - currentShift.start;
              } else if (currentShift.start > currentShift.end) {
                currentShift.end = hour.getHours() + 1;
                currentShift.hours = 24 - currentShift.start + currentShift.end;
              } else {
                currentShift.end = hour.getHours() + 1;
                currentShift.hours = currentShift.end - currentShift.start;
              }

              if (currentShift.hours == 8) {
                currentShift = false;
              }
            }
          } else {
            currentShift = false;
          }
        }
      });
      templateShifts.push(...templateShiftsStation);
    });
    setReceipts(receiptsMap);
    setLastId(id);
    return [
      templateShifts.filter(
        (ts) =>
          ts.hours >= MIN_AUTO_SHIFT_HOURS &&
          !(ts.start == 0 && ts.date == rangeStart) &&
          ts.date <= rangeEnd,
      ),
      receiptsMap,
    ];
  }

  async function loadOFD() {
    setIsLoadingReceipts(true);
    setApproveMessage(null);
    try {
      const data = await GetOFDByDatesForSchedule(
        token,
        startDate,
        DeltaDate(endDate, +1),
      );
      if (!Array.isArray(data)) {
        setApproveMessage({
          ok: false,
          text: data?.detail || "Не удалось загрузить чеки",
        });
        return;
      }
      const [templateShifts] = createTemplateShifts(data);
      setDoneTemplateShifts(templateShifts);
      setBoardReady(true);
      appendHistory({
        type: "load",
        start_date: startDate,
        end_date: endDate,
      });
    } catch (err) {
      console.error(err);
      setApproveMessage({ ok: false, text: "Не удалось загрузить чеки" });
    } finally {
      setIsLoadingReceipts(false);
    }
  }

  function addTS() {
    setDoneTemplateShifts((prev) => {
      const newId = getNextShiftId(prev);
      const shifts = [
        ...prev,
        {
          station_name: "Ночник",
          start: parseInt(startNewTS, 10),
          end: parseInt(endNewTS, 10),
          hours: TSHours,
          date: selectedDate,
          group_station_name: "Ночь",
          manual: true,
          id: newId,
        },
      ];
      setLastId(newId + 1);
      return shifts;
    });
    appendHistory({
      type: "add",
      ...historyShiftMeta({
        station_name: "Ночник",
        date: selectedDate,
        hours: TSHours,
      }),
      from: `${parseInt(startNewTS, 10)}–${parseInt(endNewTS, 10)}`,
    });
    setModalMessageCreate(<p style={{ color: "green" }}>Создано!</p>);
  }

  function validateShiftPlusHours(plus_before, plus_after, shift) {
    if (Number.isNaN(plus_before) || Number.isNaN(plus_after)) {
      return { valid: false, message: "Введите корректное число" };
    }
    if (plus_before < 0 || plus_after < 0) {
      return { valid: false, message: "Отрицательные значения!" };
    }
    if (shift.start - plus_before < 0) {
      return { valid: false, message: "Много взял сначала!" };
    }
    if (shift.hours + plus_before + plus_after >= 23) {
      return { valid: false, message: "Смена больше 23 часов!" };
    }
    return {
      valid: true,
      plus_before: parseInt(plus_before, 10),
      plus_after: parseInt(plus_after, 10),
    };
  }

  function commitShiftPlusHours(plusBeforeRaw, plusAfterRaw) {
    if (!selectedTS.id) return false;

    const plus_before = parseFloat(plusBeforeRaw);
    const plus_after = parseFloat(plusAfterRaw);
    const validation = validateShiftPlusHours(plus_before, plus_after, selectedTS);

    if (!validation.valid) {
      setModalMessageEdit(
        <p style={{ color: "red" }}>{validation.message}</p>,
      );
      setStartPlusEditTS(selectedTS.plus_before || 0);
      setEndPlusEditTS(selectedTS.plus_after || 0);
      return false;
    }

    const templateShifts = doneTemplateShifts.map((ts) => {
      if (isSameShift(ts, selectedTS)) {
        return {
          ...ts,
          plus_before: validation.plus_before,
          plus_after: validation.plus_after,
        };
      }
      return ts;
    });
    const updatedSelected = templateShifts.find((ts) => isSameShift(ts, selectedTS));
    if (!updatedSelected) return false;

    setDoneTemplateShifts(templateShifts);
    setSelectedTS(updatedSelected);
    setEditModalShift(updatedSelected);
    setStartPlusEditTS(updatedSelected.plus_before || 0);
    setEndPlusEditTS(updatedSelected.plus_after || 0);
    setModalMessageEdit("");
    return true;
  }

  function handleStartPlusInputChange(raw) {
    setStartPlusEditTS(raw);
    if (raw === "" || Number.isNaN(parseFloat(raw))) return;
    commitShiftPlusHours(raw, endPlusEditTS);
  }

  function handleEndPlusInputChange(raw) {
    setEndPlusEditTS(raw);
    if (raw === "" || Number.isNaN(parseFloat(raw))) return;
    commitShiftPlusHours(startPlusEditTS, raw);
  }

  function adjustSelectedShift(edge, delta) {
    if (!selectedTS.id) return;
    const plus_before =
      edge === "start"
        ? Math.max(0, (selectedTS.plus_before || 0) + delta)
        : selectedTS.plus_before || 0;
    const plus_after =
      edge === "end"
        ? Math.max(0, (selectedTS.plus_after || 0) + delta)
        : selectedTS.plus_after || 0;
    commitShiftPlusHours(plus_before, plus_after);
  }

  function closeEditShiftModal() {
    const modalEl = editShiftModalRef.current;
    if (modalEl) {
      Modal.getInstance(modalEl)?.hide();
    }
    setShowEditModal(false);
    setEditModalShift(null);
  }

  const openShiftEditModal = useCallback((ts) => {
    if (!ts?.id) return;
    if (
      suppressClickRef.current &&
      editModalShift &&
      isSameShift(ts, editModalShift)
    ) {
      return;
    }
    suppressClickRef.current = false;
    setModalMessageEdit("");
    setEditModalShift(ts);
    setSelectedTS(ts);
    setStartPlusEditTS(ts.plus_before || 0);
    setEndPlusEditTS(ts.plus_after || 0);
    plusSnapshotRef.current = {
      plus_before: ts.plus_before || 0,
      plus_after: ts.plus_after || 0,
      shift: ts,
    };
    setShowEditModal(true);
  }, [editModalShift]);

  function divideTS() {
    if (divideSelectedTS === 0) {
      setModalMessageEdit(<p style={{ color: "red" }}>Не выбрано деление</p>);
      return;
    }
    const templateShifts = doneTemplateShifts.map((ts) => {
      if (isSameShift(ts, selectedTS)) {
        return {
          ...ts,
          end: firstDivededTS.end,
          hours: firstDivededTS.hours,
          plus_after: 0,
        };
      }
      return ts;
    });

    const newId = getNextShiftId(templateShifts);
    const second = {
      ...selectedTS,
      start: secondDivededTS.start,
      hours: secondDivededTS.hours,
      id: newId,
      plus_before: 0,
    };

    const shifts = [...templateShifts, second];
    setDoneTemplateShifts(shifts);
    setLastId(newId + 1);
    appendHistory({
      type: "divide",
      ...historyShiftMeta(selectedTS),
      parts: [
        `${firstDivededTS.start}–${firstDivededTS.end} (${firstDivededTS.hours}ч)`,
        `${secondDivededTS.start}–${secondDivededTS.end} (${secondDivededTS.hours}ч)`,
      ],
    });
    plusSnapshotRef.current = null;
    const updatedFirst = templateShifts.find((ts) => isSameShift(ts, selectedTS));
    if (updatedFirst) {
      setSelectedTS(updatedFirst);
      setEditModalShift(updatedFirst);
    }
    closeEditShiftModal();
  }

  function dividingTS(value) {
    setDivideSelectedTS(value);
    setModalMessageEdit("");
    setFirstDiveidedTS({
      start: selectedTS.start,
      end: selectedTS.start + value,
      hours: value,
    });
    setSecondDiveidedTS({
      start: selectedTS.start + value,
      end: selectedTS.end,
      hours: getSumHoursBetween(selectedTS.start + value, selectedTS.end),
    });
  }

  const handleDragStart = useCallback((event, shift, edge) => {
    event.preventDefault();
    event.stopPropagation();
    const table = event.target.closest(".autodep-day-table");
    const weekHour = event.target
      .closest(".autodep-week")
      ?.querySelector(".autodep-week-hour");
    const hourCol = table?.querySelector(".autodep-hour-col") || weekHour;
    const hourWidth = hourCol?.offsetWidth || 32;
    dragRef.current = {
      baseShift: shift,
      edge,
      startX: event.clientX,
      hourWidth,
      initialPlusBefore: shift.plus_before || 0,
      initialPlusAfter: shift.plus_after || 0,
      lastAppliedDelta: 0,
    };
    setIsDragging(true);
    setSelectedTS(shift);
    setStartPlusEditTS(shift.plus_before || 0);
    setEndPlusEditTS(shift.plus_after || 0);
  }, []);

  const applyDragDelta = useCallback(
    (deltaHours) => {
      if (!dragRef.current) return;
      const { edge, initialPlusBefore, initialPlusAfter, baseShift } =
        dragRef.current;

      setDoneTemplateShifts((prev) =>
        prev.map((ts) => {
          if (!isSameShift(ts, baseShift)) return ts;
          if (edge === "start") {
            const plus_before = Math.max(0, initialPlusBefore - deltaHours);
            if (baseShift.start - plus_before < 0) return ts;
            if (baseShift.hours + plus_before + initialPlusAfter >= 23) {
              return ts;
            }
            return { ...ts, plus_before };
          }
          const plus_after = Math.max(0, initialPlusAfter + deltaHours);
          if (baseShift.hours + initialPlusBefore + plus_after >= 23) {
            return ts;
          }
          return { ...ts, plus_after };
        }),
      );
    },
    [],
  );

  useEffect(() => {
    if (!isDragging) return undefined;

    const onMouseMove = (event) => {
      if (!dragRef.current) return;
      const { startX, hourWidth, lastAppliedDelta } = dragRef.current;
      const deltaHours = Math.round((event.clientX - startX) / hourWidth);
      if (deltaHours === lastAppliedDelta) return;
      dragRef.current.lastAppliedDelta = deltaHours;
      applyDragDelta(deltaHours);
    };

    const onMouseUp = () => {
      if (!dragRef.current) return;
      const { baseShift, lastAppliedDelta } = dragRef.current;
      if (lastAppliedDelta !== 0) {
        suppressClickRef.current = true;
        window.setTimeout(() => {
          suppressClickRef.current = false;
        }, 400);
      }
      dragRef.current = null;
      setIsDragging(false);
      setDoneTemplateShifts((prev) => {
        const updated = prev.find((ts) => isSameShift(ts, baseShift));
        if (updated) {
          setSelectedTS(updated);
          setEditModalShift(updated);
          setStartPlusEditTS(updated.plus_before || 0);
          setEndPlusEditTS(updated.plus_after || 0);
          if (lastAppliedDelta !== 0) {
            const fromLabel = shiftIntervalLabel(
              baseShift,
              baseShift.plus_before || 0,
              baseShift.plus_after || 0,
            );
            const toLabel = shiftIntervalLabel(
              updated,
              updated.plus_before || 0,
              updated.plus_after || 0,
            );
            if (fromLabel !== toLabel) {
              appendHistory({
                type: "extend",
                ...historyShiftMeta(updated),
                from: fromLabel,
                to: toLabel,
              });
            }
            plusSnapshotRef.current = {
              plus_before: updated.plus_before || 0,
              plus_after: updated.plus_after || 0,
              shift: updated,
            };
          }
        }
        return prev;
      });
    };

    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("mouseup", onMouseUp);
    return () => {
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("mouseup", onMouseUp);
    };
  }, [isDragging, applyDragDelta]);

  useEffect(() => {
    const start = parseInt(startNewTS, 10);
    const end = parseInt(endNewTS, 10);
    if (start > 24 || end > 24 || start < 0 || end < 0 || end == start) {
      setModalMessageCreate(<p style={{ color: "red" }}>Не корректные часы</p>);
      return;
    }
    setModalMessageCreate("");
    if (end > start) {
      setTSHours(end - start);
    } else {
      setTSHours(24 - start + end);
    }
  }, [startNewTS, endNewTS]);

  useEffect(() => {
    setStartPlusEditTS(selectedTS.plus_before || 0);
    setEndPlusEditTS(selectedTS.plus_after || 0);
    setFirstDiveidedTS({});
    setSecondDiveidedTS({});
    setDivideSelectedTS(0);
  }, [getShiftKey(selectedTS)]);

  useEffect(() => {
    editModalShiftRef.current = editModalShift;
  }, [editModalShift]);

  useEffect(() => {
    if (!showEditModal || !editShiftModalRef.current) return undefined;

    const modalEl = editShiftModalRef.current;
    const modal = Modal.getOrCreateInstance(modalEl);
    modal.show();

    const onHidden = () => {
      logExtendFromSnapshot(editModalShiftRef.current);
      plusSnapshotRef.current = null;
      setShowEditModal(false);
      setEditModalShift(null);
    };
    modalEl.addEventListener("hidden.bs.modal", onHidden);

    return () => {
      modalEl.removeEventListener("hidden.bs.modal", onHidden);
    };
  }, [showEditModal]);

  const fetchDataTY = async () => {
    setIsLoadingList(true);
    try {
      const data = await GetByNotApproved(token);
      const approvesList = Array.isArray(data) ? data : [];

      if (Number(accessLevel) <= DirectorLevel && approvesList.length > 0) {
        const approve = approvesList[0];
        const templateShifts = approve.template_shifts || [];
        setStatus(approve.director_status || 1);
        setComment(approve.director_comment || "");
        setStartDate(approve.start_date);
        setEndDate(approve.end_date);
        setSelectedApprove(approve);
        setDoneTemplateShifts(templateShifts);
        const data2 = await GetOFDByDatesForSchedule(
          token,
          approve.start_date,
          DeltaDate(approve.end_date, +1),
        );
        if (Array.isArray(data2)) {
          createTemplateShifts(data2, approve.start_date, approve.end_date);
        }
        setLastId(getNextShiftId(templateShifts));
        setBoardReady(true);
      }
      setApproves(approvesList);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoadingList(false);
    }
  };

  useEffect(() => {
    fetchDataTY();
  }, [token]);

  useEffect(() => {
    const el = toolbarRef.current;
    if (!el) return undefined;
    const observer = new IntersectionObserver(
      ([entry]) => setToolbarOffscreen(!entry.isIntersecting),
      { threshold: 0 },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    return () => {
      if (savedTimerRef.current) {
        clearTimeout(savedTimerRef.current);
      }
    };
  }, []);

  async function OpenApproveTS(id) {
    setIsLoadingList(true);
    try {
      const data = await GetById(token, id);
      if (!data?.id) return;

      const templateShifts = data.template_shifts || [];
      setStatus(data.TY_status || 1);
      setComment(data.TY_comment || "");
      setSelectedApprove(data);
      setDoneTemplateShifts(templateShifts);
      setStartDate(data.start_date);
      setEndDate(data.end_date);
      const data2 = await GetOFDByDatesForSchedule(
        token,
        data.start_date,
        DeltaDate(data.end_date, +1),
      );
      if (Array.isArray(data2)) {
        createTemplateShifts(data2, data.start_date, data.end_date);
      }
      setLastId(getNextShiftId(templateShifts));
      setApproves([]);
      setBoardReady(true);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoadingList(false);
    }
  }

  async function submitApprove(statusId, commentText) {
    if (Number(selectedApprove?.TY_status) === 3) {
      return {
        ok: false,
        message: "Деп уже в расписании! Редактирование невозможно!",
      };
    }

    const data = await Approve(
      token,
      startDate,
      endDate,
      statusId,
      commentText ?? "",
      doneTemplateShifts,
      pendingHistory,
    );
    if (data.detail) {
      return { ok: false, message: data.detail };
    }

    setSelectedApprove(data);
    setStatus(statusId);
    setComment(commentText ?? "");
    setPendingHistory([]);
    return { ok: true, data };
  }

  async function saveDraft() {
    if (isSavingDraft) return { ok: false, message: "" };
    if (!(doneTemplateShifts?.length ?? 0)) {
      const message = "Нет слотов для сохранения";
      setApproveMessage({ ok: false, text: message });
      return { ok: false, message };
    }

    setIsSavingDraft(true);
    setApproveMessage(null);
    try {
      const result = await submitApprove(1, comment?.trim() || "черновик");
      if (!result.ok) {
        const message = result.message || "Не удалось сохранить";
        setApproveMessage({ ok: false, text: message });
        return { ok: false, message };
      }
      setApproveMessage({ ok: true, text: "Черновик сохранён" });
      return { ok: true, message: "Сохранено" };
    } finally {
      setIsSavingDraft(false);
    }
  }

  async function handleStickySave() {
    if (isSavingDraft || stickySaveStatus === "saving") return;
    if (savedTimerRef.current) {
      clearTimeout(savedTimerRef.current);
      savedTimerRef.current = null;
    }
    setStickySaveError("");
    setStickySaveStatus("saving");
    const result = await saveDraft();
    if (!result?.ok) {
      if (!result?.message) {
        setStickySaveStatus("save");
        return;
      }
      setStickySaveError(result.message);
      setStickySaveStatus("error");
      return;
    }
    setStickySaveStatus("saved");
    savedTimerRef.current = setTimeout(() => {
      setStickySaveStatus("save");
      savedTimerRef.current = null;
    }, 2000);
  }

  async function PostApprove() {
    setDisabledApproveBtn(true);
    setApproveMessage(null);
    if (Number(selectedApprove?.TY_status) === 3) {
      setApproveMessage({
        ok: false,
        text: "Деп уже в расписании! Редактирование невозможно!",
      });
      setDisabledApproveBtn(false);
      return;
    }

    const result = await submitApprove(status, comment);
    if (!result.ok) {
      setApproveMessage({ ok: false, text: result.message });
    } else {
      setApproveMessage({ ok: true, text: "Сохранено" });
    }
    setDisabledApproveBtn(false);
  }

  async function backListDeps() {
    setIsLoadingList(true);
    try {
      const data = await GetByNotApproved(token);
      setApproves(Array.isArray(data) ? data : []);
      setDoneTemplateShifts([]);
      setSelectedApprove({});
      setSelectedTS({ start: 0, hours: 0 });
      setBoardReady(false);
      setApproveMessage(null);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoadingList(false);
    }
  }

  function setNextWeekDates() {
    const range = getNextWeekRange();
    setStartDate(range.startDate);
    setEndDate(range.endDate);
  }

  const selectedShiftLabel = editModalShift?.id
    ? `${editModalShift.station_name} · ${editModalShift.date} · ${formatHourRange(editModalShift)}`
    : null;

  const isDirector = !(Number(accessLevel) > DirectorLevel);
  const locked = Number(selectedApprove?.TY_status) === 3;
  const weekRangeLabel =
    startDate && endDate
      ? `${formatShortDate(startDate)} — ${formatShortDate(endDate)}`
      : "";
  const isBusy = isLoadingList || isLoadingReceipts;

  const renderLoading = () => (
    <div className="schedule-chk-loading">
      <div className="spinner-border" style={{ color: "#fd0429" }} role="status">
        <span className="visually-hidden">Загрузка...</span>
      </div>
      <p>{isLoadingReceipts ? "Загрузка чеков..." : "Загрузка..."}</p>
    </div>
  );

  const legend =
    shiftPalette === "contrast" ? (
      <div className="schedule-chk-legend autodep-legend">
        <span className="schedule-chk-legend-item">
          <span className="schedule-chk-legend-swatch autodep-legend-swatch is-main" />
          Смена
        </span>
        <span className="schedule-chk-legend-item">
          <span className="schedule-chk-legend-swatch autodep-legend-swatch is-plus" />
          Удлинение
        </span>
        <span className="schedule-chk-legend-item">
          <span className="schedule-chk-legend-swatch autodep-legend-swatch is-heat" />
          Чеки по часам
        </span>
      </div>
    ) : (
      <div className="schedule-chk-legend autodep-legend">
        <span className="schedule-chk-legend-item">
          <span className="schedule-chk-legend-swatch autodep-legend-swatch is-kassa" />
          Касса
        </span>
        <span className="schedule-chk-legend-item">
          <span className="schedule-chk-legend-swatch autodep-legend-swatch is-kitchen" />
          Кухня
        </span>
        <span className="schedule-chk-legend-item">
          <span className="schedule-chk-legend-swatch autodep-legend-swatch is-bread" />
          Панировка
        </span>
        <span className="schedule-chk-legend-item">
          <span className="schedule-chk-legend-swatch autodep-legend-swatch is-hall" />
          Зал
        </span>
        <span className="schedule-chk-legend-item">
          <span className="schedule-chk-legend-swatch autodep-legend-swatch is-night" />
          Ночник
        </span>
        <span className="schedule-chk-legend-item">
          <span className="schedule-chk-legend-swatch autodep-legend-swatch is-plus" />
          Удлинение
        </span>
        <span className="schedule-chk-legend-item">
          <span className="schedule-chk-legend-swatch autodep-legend-swatch is-heat" />
          Чеки по часам
        </span>
      </div>
    );

  const board = (
    <>
      {legend}
      <div className="autodep-board-toggles">
        <div className="schedule-chk-view-toggle autodep-view-toggle">
          <button
            type="button"
            className={`schedule-chk-view-btn ${boardView === "week" ? "is-active" : ""}`}
            onClick={() => setBoardView("week")}
          >
            Неделя
          </button>
          <button
            type="button"
            className={`schedule-chk-view-btn ${boardView === "days" ? "is-active" : ""}`}
            onClick={() => setBoardView("days")}
          >
            По дням
          </button>
        </div>
        <div className="schedule-chk-view-toggle autodep-view-toggle">
          <button
            type="button"
            className={`schedule-chk-view-btn ${shiftPalette === "station" ? "is-active" : ""}`}
            onClick={() => setShiftPalette("station")}
          >
            По станциям
          </button>
          <button
            type="button"
            className={`schedule-chk-view-btn ${shiftPalette === "contrast" ? "is-active" : ""}`}
            onClick={() => setShiftPalette("contrast")}
          >
            Смена / удлинение
          </button>
        </div>
      </div>
      {boardView === "week" ? (
        <AutoDepWeek
          shifts={doneTemplateShifts}
          startDate={startDate}
          endDate={endDate}
          receipts={receipts}
          selectedShift={selectedTS}
          onSelectShift={openShiftEditModal}
          onDragStart={handleDragStart}
          onAddNight={setSelectedDate}
        />
      ) : (
        <div className="autodep-board">
          {renderAutoDepGrafic(
            { ts: doneTemplateShifts },
            startDate,
            DeltaDate(endDate, +1),
            receipts,
            setSelectedDate,
            openShiftEditModal,
            handleDragStart,
            selectedTS,
          )}
        </div>
      )}
      <AutoDepApprove
        data={selectedApprove}
        weekDates={[startDate, endDate]}
        accessLevel={accessLevel}
        status={status}
        comment={comment}
        onStatusChange={setStatus}
        onCommentChange={setComment}
        onSave={PostApprove}
        onSaveDraft={saveDraft}
        saving={disabledApproveBtn}
        savingDraft={isSavingDraft}
        message={approveMessage}
        locked={locked}
      />
    </>
  );

  return (
    <div
      className={`schedule-chk-page autodep-page${shiftPalette === "contrast" ? " autodep-palette-contrast" : ""}${isDragging ? " autodep-dragging" : ""}`}
    >
      <div className="schedule-chk-toolbar" ref={toolbarRef}>
        <div>
          <h1>Автодеп</h1>
          <p className="schedule-chk-hint">
            {isDirector
              ? "Загрузите чеки за неделю — слоты соберутся сами. Клик по смене открывает правку, край можно потянуть."
              : "Откройте деп ресторана, проверьте график и поставьте статус."}
          </p>
        </div>
        <div className="schedule-chk-toolbar-right">
          {isDirector ? (
            <>
              <div className="schedule-chk-week-picker">
                <label className="schedule-chk-week-label" htmlFor="autodep-start">
                  Неделя
                </label>
                <input
                  id="autodep-start"
                  type="date"
                  className="form-control"
                  onChange={(e) => setStartDate(e.target.value)}
                  value={startDate}
                />
                <span className="text-muted">—</span>
                <input
                  type="date"
                  className="form-control"
                  onChange={(e) => setEndDate(e.target.value)}
                  value={endDate}
                />
                <span className="schedule-chk-week-range">{weekRangeLabel}</span>
              </div>
              <select
                className="form-select autodep-toolbar-type"
                value={selectedType}
                onChange={(e) => setSelectedType(e.target.value)}
                aria-label="Тип ресторана"
              >
                <option value="IL">IL</option>
                <option value="FC">FC</option>
                <option value="DT">DT</option>
              </select>
              <button
                type="button"
                className="btn"
                onClick={loadOFD}
                disabled={isLoadingReceipts}
              >
                {isLoadingReceipts ? "Загрузка…" : "Загрузить чеки"}
              </button>
              <button
                type="button"
                className="schedule-chk-week-tool-btn"
                onClick={setNextWeekDates}
              >
                Следующая неделя
              </button>
            </>
          ) : selectedApprove?.id ? (
            <button
              type="button"
              className="schedule-chk-week-tool-btn"
              onClick={backListDeps}
            >
              ← К списку
            </button>
          ) : null}
          <Link to="/profile" className="schedule-chk-back-link">
            ← К профилю
          </Link>
        </div>
      </div>

      <div className="schedule-chk-panel">
        {isDirector ? (
          <>
            {isBusy && !boardReady ? renderLoading() : null}
            {!boardReady && !isBusy ? (
              <div className="schedule-chk-empty">
                Выберите неделю, тип ресторана и загрузите чеки — появится график
                слотов.
              </div>
            ) : null}
            {boardReady ? (
              <>
                {isBusy ? renderLoading() : null}
                {board}
              </>
            ) : null}
          </>
        ) : (
          <>
            {!selectedApprove?.id ? (
              isBusy ? (
                renderLoading()
              ) : approves.length ? (
                <ul className="autodep-ty-list">
                  {approves.map((approve) => {
                    const meta = {
                      1: "wait",
                      2: "rework",
                      3: "ok",
                    }[Number(approve.director_status) || 1];
                    return (
                      <li key={approve.id}>
                        <button
                          type="button"
                          className="autodep-ty-card"
                          onClick={() => OpenApproveTS(approve.id)}
                        >
                          <strong>
                            {approve.restaurant_name || "Ресторан"}
                          </strong>
                          <span>
                            {formatShortDate(approve.start_date)} —{" "}
                            {formatShortDate(approve.end_date)}
                          </span>
                          <em className={`chk-approve-badge is-${meta}`}>
                            {statuses[approve.director_status || 1]}
                          </em>
                        </button>
                      </li>
                    );
                  })}
                </ul>
              ) : (
                <div className="schedule-chk-empty">
                  Пусто: нет депов на согласование
                </div>
              )
            ) : (
              <>
                {isBusy && !boardReady ? renderLoading() : null}
                {boardReady ? board : null}
              </>
            )}
          </>
        )}
      </div>

      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Добавление ночника
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Закрыть"
              ></button>
            </div>
            <div className="modal-body">
              <p className="text-muted mb-3">Дата: {selectedDate}</p>
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label">Начало смены</label>
                  <input
                    type="number"
                    className="form-control"
                    min={0}
                    max={23}
                    value={startNewTS}
                    onChange={(e) => setStartNewTS(e.target.value)}
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Конец смены</label>
                  <input
                    type="number"
                    className="form-control"
                    min={0}
                    max={23}
                    value={endNewTS}
                    onChange={(e) => setEndNewTS(e.target.value)}
                  />
                </div>
                <div className="col-12">
                  <label className="form-label">Кол-во часов</label>
                  <input
                    type="number"
                    className="form-control"
                    disabled
                    value={TSHours}
                  />
                </div>
              </div>
              <div className="autodep-hour-presets mt-3">
                {[
                  [22, 6],
                  [23, 7],
                  [0, 8],
                ].map(([start, end]) => (
                  <button
                    key={`${start}-${end}`}
                    type="button"
                    className="btn btn-sm btn-outline-secondary me-2 mb-2"
                    onClick={() => {
                      setStartNewTS(start);
                      setEndNewTS(end);
                    }}
                  >
                    {start}:00 — {end}:00
                  </button>
                ))}
              </div>
            </div>
            <div className="text-center">{modalMessageCreate}</div>
            <div className="modal-footer">
              <button type="button" className="btn" data-bs-dismiss="modal">
                Закрыть
              </button>
              <button type="button" className="btn btn-primary" onClick={addTS}>
                Создать смену
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="editShiftModal"
        ref={editShiftModalRef}
        tabIndex="-1"
        aria-labelledby="editShiftModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="editShiftModalLabel">
                Редактирование смены
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Закрыть"
              ></button>
            </div>
            {editModalShift?.id && (
              <>
                <div className="modal-body">
                  <div className="alert alert-light border mb-3">
                    <div className="fw-semibold">{selectedShiftLabel}</div>
                  </div>

                  <div className="fw-semibold mb-2">Длина смены</div>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label className="form-label">Начало (добавить часы слева)</label>
                      <div className="input-group">
                        <button
                          type="button"
                          className="btn btn-outline-danger"
                          onClick={() => adjustSelectedShift("start", -1)}
                        >
                          −
                        </button>
                        <input
                          type="number"
                          className="form-control text-center"
                          value={startPlusEditTS}
                          onChange={(e) => handleStartPlusInputChange(e.target.value)}
                          onBlur={() => {
                            if (
                              startPlusEditTS === "" ||
                              Number.isNaN(parseFloat(startPlusEditTS))
                            ) {
                              setStartPlusEditTS(selectedTS.plus_before || 0);
                            }
                          }}
                          min={0}
                        />
                        <button
                          type="button"
                          className="btn btn-outline-success"
                          onClick={() => adjustSelectedShift("start", 1)}
                        >
                          +
                        </button>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Конец (добавить часы справа)</label>
                      <div className="input-group">
                        <button
                          type="button"
                          className="btn btn-outline-danger"
                          onClick={() => adjustSelectedShift("end", -1)}
                        >
                          −
                        </button>
                        <input
                          type="number"
                          className="form-control text-center"
                          value={endPlusEditTS}
                          onChange={(e) => handleEndPlusInputChange(e.target.value)}
                          onBlur={() => {
                            if (
                              endPlusEditTS === "" ||
                              Number.isNaN(parseFloat(endPlusEditTS))
                            ) {
                              setEndPlusEditTS(selectedTS.plus_after || 0);
                            }
                          }}
                          min={0}
                        />
                        <button
                          type="button"
                          className="btn btn-outline-success"
                          onClick={() => adjustSelectedShift("end", 1)}
                        >
                          +
                        </button>
                      </div>
                    </div>
                  </div>

                  <hr className="my-4" />

                  <div className="fw-semibold mb-2">Деление смены</div>
                  <label htmlFor="divideShiftRange" className="form-label">
                    Точка разделения (часы от начала)
                  </label>
                  <input
                    onChange={(e) => dividingTS(parseInt(e.target.value, 10))}
                    type="range"
                    className="form-range"
                    min="0"
                    max={Math.max(0, editModalShift.hours - 1)}
                    step={1}
                    value={divideSelectedTS}
                    id="divideShiftRange"
                  />
                  <div className="d-flex justify-content-between small text-muted">
                    <span>
                      Первая: {firstDivededTS.start} — {firstDivededTS.end}
                    </span>
                    <span>
                      Вторая: {secondDivededTS.start} — {secondDivededTS.end}
                    </span>
                  </div>
                </div>
                <div className="text-center px-3">{modalMessageEdit}</div>
                <div className="modal-footer">
                  <button type="button" className="btn" data-bs-dismiss="modal">
                    Закрыть
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-primary"
                    onClick={divideTS}
                  >
                    Разделить
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {isDirector && boardReady && !locked && toolbarOffscreen ? (
        <button
          type="button"
          className={`btn autodep-sticky-save${stickySaveStatus === "error" ? " is-error" : ""}`}
          onClick={handleStickySave}
          disabled={isSavingDraft || stickySaveStatus === "saving"}
        >
          {stickySaveStatus === "saving"
            ? "Сохранение…"
            : stickySaveStatus === "saved"
              ? "Сохранено"
              : stickySaveStatus === "error"
                ? stickySaveError
                : "Сохранить"}
        </button>
      ) : null}

    </div>
  );
};

export default AutoDep;

function formatShortDate(dateString) {
  if (!dateString) return "";
  const iso = String(dateString).slice(0, 10);
  const [, month, day] = iso.split("-");
  return day && month ? `${day}.${month}` : iso;
}

function formatDayHead(dateString) {
  const iso = String(dateString).slice(0, 10);
  const [year, month, day] = iso.split("-").map(Number);
  if (!year || !month || !day) return iso;
  const date = new Date(year, month - 1, day);
  const weekdays = ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"];
  return `${weekdays[date.getDay()]} ${String(day).padStart(2, "0")}.${String(month).padStart(2, "0")}`;
}

function weekdayFromDate(dateString) {
  const iso = String(dateString || "").slice(0, 10);
  const [year, month, day] = iso.split("-").map(Number);
  if (!year || !month || !day) return "";
  return ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"][
    new Date(year, month - 1, day).getDay()
  ];
}

function shiftIntervalLabel(ts, plusBefore = 0, plusAfter = 0) {
  const start = Number(ts?.start) - (Number(plusBefore) || 0);
  const endRaw = Number(ts?.end) + (Number(plusAfter) || 0);
  const end = endRaw < 24 ? endRaw : endRaw - 24;
  return `${start}–${end}`;
}

function historyNowIso() {
  const date = new Date();
  const pad = (value) => String(value).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}

function historyShiftMeta(ts) {
  return {
    station: ts?.station_name || "",
    weekday: weekdayFromDate(ts?.date),
    date: String(ts?.date || "").slice(0, 10),
    hours: ts?.hours || 0,
  };
}

function shiftTone(ts) {
  if (ts?.manual || ts?.group_station_name === "Ночь") return "night";
  switch (ts?.group_station_name) {
    case "Касса":
      return "kassa";
    case "Кухня":
      return "kitchen";
    case "Панировка":
      return "bread";
    case "Зал":
      return "hall";
    default:
      return "shift";
  }
}

function receiptsAt(receipts, dateStr, hour) {
  const dt = new Date(dateStr);
  dt.setHours(hour);
  return Number(receipts[dt.getTime()]?.receipts) || 0;
}

function heatLevel(count, max) {
  if (!max || !count) return 0;
  const t = count / max;
  if (t <= 0.2) return 1;
  if (t <= 0.4) return 2;
  if (t <= 0.6) return 3;
  if (t <= 0.8) return 4;
  return 5;
}

function pushAutoDepShiftRow(
  templateShift,
  startGroup,
  offset,
  groupName,
  before,
  plusBefore,
  hours,
  plusAfter,
  after,
  showStart,
  showEnd,
  onSelectShift,
  onDragStart,
  selectedShift,
) {
  const tone = shiftTone(templateShift);
  const isSelected = isSameShift(selectedShift, templateShift);
  const openShiftEditor = () => onSelectShift(templateShift);

  const renderCell = (key, className, children, handlers = {}) => (
    <td key={key} className={className} {...handlers}>
      {children}
    </td>
  );

  const stopHandleClick = {
    onClick: (e) => e.stopPropagation(),
  };

  const cells = [];
  for (let i = 0; i < before; i += 1) {
    cells.push(renderCell(`b${i}`, "", null));
  }

  for (let i = 0; i < plusBefore; i += 1) {
    const isFirst = i === 0;
    cells.push(
      renderCell(
        `pb${i}`,
        `autodep-plus-cell autodep-shift-cell autodep-shift--${tone}${isFirst ? " autodep-plus-start" : ""}${isSelected ? " autodep-selected" : ""}`,
        isFirst ? (
          <span
            className="autodep-handle autodep-handle-start"
            onMouseDown={(e) => onDragStart(e, templateShift, "start")}
            {...stopHandleClick}
            title="Потяните, чтобы изменить начало"
          />
        ) : null,
      ),
    );
  }

  for (let i = 0; i < hours; i += 1) {
    const isFirstMain = plusBefore === 0 && i === 0;
    const isLastMain = plusAfter === 0 && i === hours - 1;
    cells.push(
      renderCell(
        `h${i}`,
        `autodep-shift-cell autodep-shift--${tone}${isSelected ? " autodep-selected" : ""}`,
        <>
          {isFirstMain && (
            <span
              className="autodep-handle autodep-handle-start"
              onMouseDown={(e) => onDragStart(e, templateShift, "start")}
              {...stopHandleClick}
              title="Потяните, чтобы изменить начало"
            />
          )}
          {isLastMain && (
            <span
              className="autodep-handle autodep-handle-end"
              onMouseDown={(e) => onDragStart(e, templateShift, "end")}
              {...stopHandleClick}
              title="Потяните, чтобы изменить конец"
            />
          )}
        </>,
      ),
    );
  }

  for (let i = 0; i < plusAfter; i += 1) {
    const isLast = i === plusAfter - 1;
    cells.push(
      renderCell(
        `pa${i}`,
        `autodep-plus-cell autodep-shift-cell autodep-shift--${tone}${isLast ? " autodep-plus-end" : ""}${isSelected ? " autodep-selected" : ""}`,
        isLast ? (
          <span
            className="autodep-handle autodep-handle-end"
            onMouseDown={(e) => onDragStart(e, templateShift, "end")}
            {...stopHandleClick}
            title="Потяните, чтобы изменить конец"
          />
        ) : null,
      ),
    );
  }

  for (let i = 0; i < after; i += 1) {
    cells.push(renderCell(`a${i}`, "", null));
  }

  return (
    <tr
      key={`ts_${getShiftKey(templateShift)}_${showStart}_${showEnd}`}
      className={`autodep-shift-row${isSelected ? " autodep-row-selected" : ""}`}
      onClick={openShiftEditor}
    >
      {startGroup && (
        <td rowSpan={offset} className="align-middle fw-semibold autodep-meta-col">
          {groupName}
        </td>
      )}
      <td className={`align-middle autodep-meta-col autodep-station-cell is-${tone}`}>
        {templateShift.station_name}
      </td>
      <td className="text-center align-middle autodep-meta-col">
        {showStart} — {showEnd}
      </td>
      {cells}
    </tr>
  );
}

function calcAutoDepCells(
  ts,
  date,
  startGroup,
  group,
  groupName,
  onSelectShift,
  onDragStart,
  selectedShift,
) {
  const tsDate = new Date(ts.date);
  const previousDay = new Date(date);
  previousDay.setDate(previousDay.getDate() - 1);

  let before = 0;
  let after = 0;
  let hours = 0;
  let plusBefore = ts.plus_before || 0;
  let plusAfter = ts.plus_after || 0;
  const showStart = ts.start - plusBefore;
  const showEnd =
    ts.end + plusAfter < 24 ? ts.end + plusAfter : ts.end + plusAfter - 24;

  if (ts.date === date) {
    if (ts.end > ts.start) {
      before = ts.start;
      after = 24 - ts.start - ts.hours;
      hours = ts.hours;
      if (plusAfter && ts.end + plusAfter < 24) {
        after -= plusAfter;
      } else if (plusAfter !== 0) {
        plusAfter -= plusAfter - after;
        after = 0;
      }
      if (plusBefore && ts.start - plusBefore > 0) {
        before -= plusBefore;
      } else if (plusBefore) {
        plusBefore = before;
        before = 0;
      }
    } else if (ts.start > ts.end) {
      before = ts.start - plusBefore;
      after = 0;
      plusAfter = 0;
      hours = 24 - ts.start;
    }
    return pushAutoDepShiftRow(
      ts,
      startGroup,
      group.length,
      groupName,
      before,
      plusBefore,
      hours,
      plusAfter,
      after,
      showStart,
      showEnd,
      onSelectShift,
      onDragStart,
      selectedShift,
    );
  }

  if (
    tsDate.getTime() === previousDay.getTime() &&
    (ts.start > ts.end ||
      (ts.start - plusBefore > ts.end + plusAfter - 24 &&
        ts.end + plusAfter - 24 > 0))
  ) {
    before = 0;
    after = 24 - ts.end;
    hours = ts.end;

    if (plusBefore) {
      plusBefore = 0;
    }

    if (ts.end + plusAfter > 24) {
      before = 0;
      plusBefore = 0;
      hours = 0;
      plusAfter = plusAfter - after;
      after = 24 - plusAfter;
    } else if (plusAfter) {
      after -= plusAfter;
    }

    return pushAutoDepShiftRow(
      ts,
      startGroup,
      group.length,
      groupName,
      before,
      plusBefore,
      hours,
      plusAfter,
      after,
      showStart,
      showEnd,
      onSelectShift,
      onDragStart,
      selectedShift,
    );
  }

  return null;
}

function renderAutoDepGrafic(
  data,
  startDate,
  endDate,
  receipts,
  setDate,
  onSelectShift,
  onDragStart,
  selectedShift,
) {
  const templateShifts = data.ts;
  const tables = [];

  const start = new Date(startDate);
  const end = new Date(endDate);
  for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
    const date = d.toISOString().split("T")[0];
    const body = [];
    const demoShifts = [];

    for (let ts of templateShifts) {
      const tsDate = new Date(ts.date);
      const previousDay = new Date(date);
      previousDay.setDate(previousDay.getDate() - 1);
      const plus_before = ts.plus_before || 0;
      const plus_after = ts.plus_after || 0;
      if (ts.date == date) {
        demoShifts.push(ts);
      }
      if (
        tsDate.getTime() === previousDay.getTime() &&
        (ts.start > ts.end ||
          (ts.start - plus_before > ts.end + plus_after - 24 &&
            plus_after &&
            ts.end + plus_after - 24 > 0))
      ) {
        if (ts.end != 0) {
          demoShifts.push(ts);
        }
      }
    }

    const ord_ts_date = demoShifts.sort((a, b) =>
      a.group_station_name.localeCompare(b.group_station_name),
    );
    const grouped = ord_ts_date.reduce((groups, ts) => {
      const key = ts.group_station_name;
      if (!groups[key]) {
        groups[key] = [];
      }
      groups[key].push(ts);
      return groups;
    }, {});

    for (let groupName in grouped) {
      grouped[groupName].sort((a, b) => a.start - b.start);
    }

    for (let groupName in grouped) {
      const group = grouped[groupName];
      let startGroup = true;
      for (let ts of group) {
        const row = calcAutoDepCells(
          ts,
          date,
          startGroup,
          group,
          groupName,
          onSelectShift,
          onDragStart,
          selectedShift,
        );
        if (row) {
          body.push(row);
        }
        startGroup = false;
      }
    }

    const hourCounts = Array.from({ length: 24 }, (_, hour) =>
      receiptsAt(receipts, date, hour),
    );
    const maxReceipts = Math.max(0, ...hourCounts);
    const dayReceipts = hourCounts.reduce((sum, count) => sum + count, 0);

    tables.push(
      <div className="autodep-day" key={date}>
        <div className="autodep-day-head">
          <h3>{formatDayHead(date)}</h3>
          <span>{dayReceipts} чеков за день</span>
        </div>
        <div className="table-responsive autodep-day-wrap">
          <table className="table table-bordered text-center autodep-day-table">
            <thead>
              <tr>
                <th scope="col" className="autodep-meta-col">
                  Группа
                </th>
                <th scope="col" className="autodep-meta-col">
                  Позиция
                </th>
                <th scope="col" className="autodep-meta-col">
                  С — По
                </th>
                {hourCounts.map((count, hour) => (
                  <th
                    key={hour}
                    className={`text-center autodep-hour-col is-heat-${heatLevel(count, maxReceipts)}`}
                    scope="col"
                    title={`${hour}:00 · ${count} чеков`}
                  >
                    <span className="autodep-hour-num">{hour}</span>
                    <span className="autodep-hour-receipts">{count}</span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {body}
              <tr className="autodep-night-row">
                <td colSpan={3}>
                  <button
                    type="button"
                    className="schedule-chk-week-tool-btn is-primary"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                    onClick={() => setDate(date)}
                  >
                    + Ночник
                  </button>
                </td>
                <td colSpan={24} />
              </tr>
            </tbody>
          </table>
        </div>
      </div>,
    );
  }
  return tables;
}

function formatHourRange(ts) {
  const start = ts.start - (ts.plus_before || 0);
  const endRaw = ts.end + (ts.plus_after || 0);
  const end = endRaw < 24 ? endRaw : endRaw - 24;
  return `${start}:00 — ${end}:00`;
}

const ILDeploiment = [
  { min_receipts: 1, name: "Кассир 1", group_station_name: "Касса" },
  { min_receipts: 1, name: "Панировщик 1", group_station_name: "Панировка" },
  { min_receipts: 1, name: "Кликун", group_station_name: "Кухня" },
  { min_receipts: 1, name: "Зал", group_station_name: "Зал" },
  { min_receipts: 16, name: "Пакер 1", group_station_name: "Касса" },
  { min_receipts: 25, name: "Сандвичи 1", group_station_name: "Кухня" },
  { min_receipts: 36, name: "Пакер 2", group_station_name: "Касса" },
  { min_receipts: 46, name: "Презентор 1", group_station_name: "Касса" },
  { min_receipts: 46, name: "Панировщик 2", group_station_name: "Панировка" },
  { min_receipts: 56, name: "Сандвичи 2", group_station_name: "Кухня" },
  { min_receipts: 56, name: "Напитки и Десерты", group_station_name: "Касса" },
  { min_receipts: 86, name: "Жаровщик", group_station_name: "Панировка" },
  { min_receipts: 86, name: "Картофель Фри", group_station_name: "Кухня" },
  { min_receipts: 86, name: "Пакер 3", group_station_name: "Касса" },
  { min_receipts: 126, name: "Кассир 2", group_station_name: "Касса" },
  { min_receipts: 136, name: "Сбор доставки", group_station_name: "Касса" },
  { min_receipts: 146, name: "Упаковщик", group_station_name: "Касса" },
  { min_receipts: 156, name: "Презентор 2", group_station_name: "Касса" },
  { min_receipts: 176, name: "Кассир 3", group_station_name: "Касса" },
  { min_receipts: 186, name: "Пакер 4", group_station_name: "Касса" },
  { min_receipts: 236, name: "Пакер 5", group_station_name: "Касса" },
];

const FCDeploiment = [
  { min_receipts: 1, name: "Кассир 1", group_station_name: "Касса" },
  { min_receipts: 1, name: "Панировщик 1", group_station_name: "Панировка" },
  { min_receipts: 1, name: "Кликун", group_station_name: "Кухня" },
  { min_receipts: 6, name: "Пакер 1", group_station_name: "Касса" },
  { min_receipts: 26, name: "Сандвичи 1", group_station_name: "Кухня" },
  { min_receipts: 36, name: "Пакер 2", group_station_name: "Касса" },
  { min_receipts: 46, name: "Презентор 1", group_station_name: "Касса" },
  { min_receipts: 46, name: "Панировщик 2", group_station_name: "Панировка" },
  { min_receipts: 46, name: "Напитки и Десерты", group_station_name: "Касса" },
  { min_receipts: 66, name: "Сандвичи 2", group_station_name: "Кухня" },
  { min_receipts: 86, name: "Жаровщик", group_station_name: "Панировка" },
  { min_receipts: 86, name: "Картофель Фри", group_station_name: "Кухня" },
  { min_receipts: 86, name: "Пакер 3", group_station_name: "Касса" },
  { min_receipts: 126, name: "Кассир 2", group_station_name: "Касса" },
  { min_receipts: 136, name: "Сбор доставки", group_station_name: "Касса" },
  { min_receipts: 146, name: "Упаковщик", group_station_name: "Касса" },
  { min_receipts: 156, name: "Презентор 2", group_station_name: "Касса" },
  { min_receipts: 176, name: "Кассир 3", group_station_name: "Касса" },
  { min_receipts: 186, name: "Пакер 4", group_station_name: "Касса" },
  { min_receipts: 236, name: "Пакер 5", group_station_name: "Касса" },
];

const DTDeploiment = [
  { min_receipts: 5, name: "Кассир 1", group_station_name: "Касса" },
  { min_receipts: 5, name: "Панировщик 1", group_station_name: "Панировка" },
  { min_receipts: 5, name: "Кликун", group_station_name: "Кухня" },
  { min_receipts: 5, name: "DT Оплата", group_station_name: "Касса" },
  { min_receipts: 5, name: "Зал", group_station_name: "Зал" },
  { min_receipts: 16, name: "Пакер 1", group_station_name: "Касса" },
  { min_receipts: 26, name: "Сандвичи 1", group_station_name: "Кухня" },
  { min_receipts: 36, name: "DT Сбор", group_station_name: "Касса" },
  { min_receipts: 46, name: "Панировщик 2", group_station_name: "Панировка" },
  { min_receipts: 56, name: "Сандвичи 2", group_station_name: "Кухня" },
  { min_receipts: 56, name: "Презентор 1", group_station_name: "Касса" },
  { min_receipts: 86, name: "Жаровщик", group_station_name: "Панировка" },
  { min_receipts: 86, name: "Картофель Фри", group_station_name: "Кухня" },
  { min_receipts: 86, name: "DT Прием", group_station_name: "Касса" },
  { min_receipts: 86, name: "DT Выдача", group_station_name: "Касса" },
  { min_receipts: 96, name: "Пакер 2", group_station_name: "Касса" },
  { min_receipts: 126, name: "Кассир 2", group_station_name: "Касса" },
  { min_receipts: 156, name: "DT Проверка", group_station_name: "Касса" },
  { min_receipts: 227, name: "Презентор 2", group_station_name: "Касса" },
];

const selectDeploiment = {
  IL: ILDeploiment,
  FC: FCDeploiment,
  DT: DTDeploiment,
};

const generateHours = (startDate, endDate) => {
  const start = new Date(`${startDate}T00:00:00`);
  const end = new Date(endDate);
  end.setDate(end.getDate() + 1);
  end.setHours(0, 0, 0, 0);

  const hours = [];
  const current = new Date(start);

  while (current <= end) {
    hours.push(new Date(current));
    current.setHours(current.getHours() + 1);
  }

  return hours;
};

function hoursInDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

function DeltaDate(dateStr, days) {
  const date = new Date(dateStr);
  date.setDate(date.getDate() + days);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

function getSumHoursBetween(start, end) {
  if (end == 0) {
    end = 24;
  }
  if (end > start) {
    return end - start;
  }
  return 24 - start + end;
}
